document.addEventListener("DOMContentLoaded", function() {
  // 获取所有弹窗触发按钮
  const openBtns = document.querySelectorAll(".pop_up_size_title");

  openBtns.forEach(openBtn => {
    // 每个按钮对应的弹窗
    const popup = openBtn.closest(".options-popUP-title").querySelector(".customHtml-optionsUP-box-content");
    const closeBtn = popup.querySelector(".customHtml-swiperUpClose-box-btns");

    if (popup && closeBtn) {
      // 打开弹窗
      openBtn.addEventListener("click", (e) => {
        e.stopPropagation(); // 阻止冒泡
        popup.classList.add("active");
        document.body.classList.add("no-scroll");
      });

      // 关闭按钮
      closeBtn.addEventListener("click", (e) => {
        e.stopPropagation(); // 阻止冒泡
        popup.classList.remove("active");
        document.body.classList.remove("no-scroll");
      });

      // 点击外部区域关闭
      document.addEventListener("click", (e) => {
        if (popup.classList.contains("active") && !popup.contains(e.target) && !openBtn.contains(e.target)) {
          popup.classList.remove("active");
          document.body.classList.remove("no-scroll");
        }
      });
    }
  });
});

// footer nav
document.addEventListener("DOMContentLoaded", function () {
  var accly = document.getElementsByClassName("footer__block--title__column");
  var i;
  for (i = 0; i < accly.length; i++) {
    accly[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var footer__block__ecroe_column = this.nextElementSibling;
      console.log(footer__block__ecroe_column);
      if (footer__block__ecroe_column.style.maxHeight) {
        footer__block__ecroe_column.style.maxHeight = null;
      } else {
        footer__block__ecroe_column.style.maxHeight =
          footer__block__ecroe_column.scrollHeight + "px";
      }
    });
  }
});

// cart countdown
document.addEventListener('DOMContentLoaded', function () {
  (function () {
    const COUNTDOWN_MINUTES = 10;
    const STORAGE_KEY = 'cart_countdown_end';
    let timerInterval = null;

    function updateDisplay(minutes, seconds, element) {
      if (!element) return;
      const m = minutes.toString().padStart(2, '0');
      const s = seconds.toString().padStart(2, '0');
      element.textContent = `${m}m ${s}s`;
    }

    function getRemainingSeconds() {
      const endTime = localStorage.getItem(STORAGE_KEY);
      if (!endTime) return 0;
      return Math.floor((endTime - Date.now()) / 1000);
    }

    function startTimer() {
      const countdownContainer = document.getElementById('cart-countdown');
      const timerDisplay = document.getElementById('countdown-timer');
      if (!countdownContainer || !timerDisplay) return;

      clearInterval(timerInterval);

      let remaining = getRemainingSeconds();

      if (remaining <= 0) {
        const endTime = Date.now() + COUNTDOWN_MINUTES * 60 * 1000;
        localStorage.setItem(STORAGE_KEY, endTime);
        remaining = COUNTDOWN_MINUTES * 60;
      }

      countdownContainer.style.display = 'block';

      timerInterval = setInterval(() => {
        remaining--;

        if (remaining <= 0) {
          clearInterval(timerInterval);
          localStorage.removeItem(STORAGE_KEY);
          // countdownContainer.innerHTML = "<p>Your reservation has expired!</p>";
          countdownContainer.style.display = 'none';
          return;
        }

        const mins = Math.floor(remaining / 60);
        const secs = remaining % 60;
        updateDisplay(mins, secs, timerDisplay);
      }, 1000);
    }

    function watchDrawer() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      const observer = new MutationObserver(() => {
        if (drawer.classList.contains('active')) {
          startTimer();
        } else {
          clearInterval(timerInterval);
        }
      });

      observer.observe(drawer, { attributes: true });
    }

    document.addEventListener('cart:updated', function () {
      setTimeout(() => {
        startTimer();
      }, 300);
    });

    function watchCartContent() {
      const target = document.querySelector('cart-drawer');
      if (!target) return;

      const observer = new MutationObserver(() => {
        startTimer();
      });

      observer.observe(target, { childList: true, subtree: true });
    }

    watchDrawer();
    watchCartContent();
  })();
});